import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

const StyledModalTabs = styled.div`
  display: flex;
  padding: 0 32px 0 32px;
  margin-bottom: 0;
  border-bottom: 1px solid ${colors.secondary80};
  gap: 10px;
`

const Tab = styled.div`
  padding: 12px 14px 14px 16px;
  color: ${colors.secondary40};
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: ${colors.primary35};
  }

  ${props => props.active && css`
    color: ${colors.primary35};
    border-bottom: 2px solid ${colors.primary35};
  `}
`

const ModalTabs = ({ tabs, activeTabId, onTabChange }) => {
  return (
    <StyledModalTabs>
      {tabs.map(tab => {
        const isActive = Boolean(activeTabId === tab.id)
        return (
          <Tab
            key={tab.id}
            onClick={(e) => onTabChange(tab)}
            active={isActive}
            data-test={tab.id}
          >
            {tab.title}
          </Tab>
        )
      })}
    </StyledModalTabs>
  )
}

ModalTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  activeTabId: PropTypes.string,
  onTabChange: PropTypes.func.isRequired,
}

export default ModalTabs
